import { useMemo } from 'react'
import { Room } from './PersonSelector.types'
import { useTranslations } from '@/core/translation'

export const useGetSummaryLabel = (rooms: Room[], roomSelector?: boolean) => {
  const t = useTranslations('personSelector')

  return useMemo(() => {
    const totalAdults = rooms.reduce((sum, r) => sum + r.adults, 0)
    const totalChildren = rooms.reduce((sum, r) => sum + r.children, 0)
    const total = totalAdults + totalChildren
    const roomCount = rooms.length

    return roomSelector
      ? t('summaryRoom', { total, rooms: roomCount })
      : t('summary', { adults: totalAdults, children: totalChildren })
  }, [roomSelector, rooms, t])
}
